import React from 'react';
import TextBox from './components/TextBox';
import Counter from './components/Counter';

const countChar = props => {
  const { txtLabel, countChar, numChar, ringStyle ,handleChange , errors, touched, name, handleBlur, values, maxLenghtNum} = props;

  return (
    <div id="TextCounterMain" style={{ width: '100%' }}>
      <TextBox txtLabel={txtLabel} maxLenghtNum={maxLenghtNum} countChar={countChar} handleChange={handleChange} errors={errors} touched={touched} values={values} name={name} handleBlur={handleBlur}/>

      {numChar && numChar>0?  <Counter numChar={numChar} ringStyle={ringStyle}  /> : null}
    </div>
  );
};

export default countChar;
